import { render, staticRenderFns } from "./HomeFeatures.vue?vue&type=template&id=54ec7060&scoped=true&"
import script from "./HomeFeatures.vue?vue&type=script&lang=js&"
export * from "./HomeFeatures.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeatures.vue?vue&type=style&index=0&id=54ec7060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec7060",
  null
  
)

export default component.exports